import { NarrativeTemplate } from './templates'

export const executiveTemplates: NarrativeTemplate[] = [
  // Excellent performance
  {
    id: 'executive-excellent',
    category: 'executive',
    condition: (data) => Number(data.overallReliability) >= 95,
    priority: 100,
    template: `{period} EXECUTIVE SUMMARY

FLEET PERFORMANCE: EXCELLENT

Key Metrics:
• Overall Reliability: {reliabilityFormatted} ({reliabilityChange} vs previous period)
• Unplanned Downtime: {downtimeFormatted} ({downtimeImprovement} improvement)
• Prediction Accuracy: {accuracyFormatted}
• Estimated Savings: {savingsFormatted}

KEY WINS:
{keyWinsFormatted}

The fleet is performing above target levels. Predictive maintenance is effectively preventing failures, with {criticalPrevented} critical incidents avoided this period.

AREAS OF FOCUS:
{attentionFormatted}

Recommendation: Maintain current operational practices while addressing the noted attention items.`
  },

  // Improving trend
  {
    id: 'executive-improving',
    category: 'executive',
    condition: (data) => data.reliabilityTrend === 'improving' || data.reliabilityTrend === 'significantly improving',
    priority: 90,
    template: `{period} EXECUTIVE SUMMARY

FLEET PERFORMANCE: IMPROVING

Trend Analysis:
• Reliability: {reliabilityFormatted} ({reliabilityChange} improvement)
• Trend: {reliabilityTrend}
• Downtime Reduction: {downtimeImprovement}
• Cost Savings: {savingsFormatted}

KEY ACHIEVEMENTS:
{keyWinsFormatted}

The positive trend indicates that recent operational changes and predictive maintenance investments are delivering results. {criticalPrevented} potential critical failures were prevented.

REQUIRES ATTENTION:
{attentionFormatted}

Recommendation: Continue current trajectory while addressing attention items to sustain improvement.`
  },

  // Needs attention
  {
    id: 'executive-attention',
    category: 'executive',
    condition: (data) => Number(data.overallReliability) < 90,
    priority: 85,
    template: `{period} EXECUTIVE SUMMARY

FLEET PERFORMANCE: REQUIRES ATTENTION

Current Status:
• Reliability: {reliabilityFormatted}
• Trend: {reliabilityTrend}
• Downtime: {downtimeFormatted}
• Prediction Accuracy: {accuracyFormatted}

URGENT ITEMS:
{attentionFormatted}

RECENT POSITIVES:
{keyWinsFormatted}

Analysis indicates that fleet reliability is below optimal levels. Focused intervention on the items requiring attention is recommended to prevent further degradation.

RECOMMENDED ACTIONS:
1. Prioritize critical maintenance on flagged assets
2. Review maintenance scheduling for efficiency
3. Consider additional resources for high-priority interventions

Investment of {savingsFormatted} in proactive maintenance is projected based on current analysis.`
  },

  // Declining trend
  {
    id: 'executive-declining',
    category: 'executive',
    condition: (data) => data.reliabilityTrend === 'declining' || data.reliabilityTrend === 'significantly declining',
    priority: 95,
    template: `{period} EXECUTIVE SUMMARY

FLEET PERFORMANCE: DECLINING TREND DETECTED

Warning Indicators:
• Current Reliability: {reliabilityFormatted} ({reliabilityChange})
• Trend Direction: {reliabilityTrend}
• Downtime Impact: {downtimeFormatted}

CRITICAL ATTENTION REQUIRED:
{attentionFormatted}

MITIGATING FACTORS:
{keyWinsFormatted}

The declining trend requires immediate management attention. Root cause analysis is recommended to identify systemic issues.

IMMEDIATE ACTIONS:
1. Emergency review of critical asset status
2. Accelerate pending maintenance activities
3. Increase monitoring frequency on at-risk assets

Prompt action can reverse this trend and prevent significant downtime costs.`
  },

  // Default
  {
    id: 'executive-default',
    category: 'executive',
    priority: 10,
    template: `{period} EXECUTIVE SUMMARY

Fleet Reliability: {reliabilityFormatted}
Trend: {reliabilityTrend}
Unplanned Downtime: {downtimeFormatted}
Prediction Accuracy: {accuracyFormatted}
Critical Failures Prevented: {criticalPrevented}
Estimated Savings: {savingsFormatted}

KEY POINTS:
{keyWinsFormatted}

ATTENTION ITEMS:
{attentionFormatted}`
  }
]
